import { createContext, useReducer, useContext } from "react";
import reduce from "./reduce";
const ContextVariable = createContext();

export function ContextProvider({ children }) {
  const [{ Data, filterBy }, dispatch] = useReducer(reduce, {
    Data: [],
    filterBy: ""
  });
  return (
    <ContextVariable.Provider value={{ Data, dispatch, filterBy }}>
      {children}
    </ContextVariable.Provider>
  );
}

export function useProvider() {
  return useContext(ContextVariable);
}
